module.exports = __webpack_public_path__ + "media/shapes-preview@sm-e87d5cbac4ce094c268bedbca16c6b40.gif";